import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesTagsGetAsyncSlice } from './get';

export const coreInitiativesTagsReducers = combineReducers({
	get: coreInitiativesTagsGetAsyncSlice.asyncReducers
});

export const coreInitiativesTagsWatchers = combineAllWatchers([ coreInitiativesTagsGetAsyncSlice.asyncWatchers ]);
